import React from 'react';
import { cdew, seduction } from '../data/homepage';
import { COEUR_PATH } from './HeroCarousel';
const coralButton = 'inline-flex items-center rounded-sm border-2 border-ville-coral px-6 py-3 text-sm font-bold uppercase tracking-wider text-ville-coral transition-colors duration-150 ease-ville hover:bg-ville-coral hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-coral focus-visible:ring-offset-2';
export function Events() {
  const [first, second, third] = seduction.images;
  return <>
      <section aria-labelledby="seduction-titre" className="relative overflow-hidden bg-white py-16 lg:py-24" data-id="element-1316" data-mp="1tamjcez7jyzb">
        <svg viewBox="0 0 100 100" aria-hidden="true" className="pointer-events-none absolute -left-[16%] top-4 h-[420px] w-auto sm:-left-[8%] lg:h-[560px]" data-id="element-1317" data-mp="1y7w6tp31e0ki">
          <path d={COEUR_PATH} fill="#e9554a" data-id="element-1318" data-mp="39o4do2pi3y1z" />
        </svg>
        <svg viewBox="0 0 100 100" aria-hidden="true" className="pointer-events-none absolute left-[4%] top-10 h-[360px] w-auto lg:h-[480px]" data-id="element-1319" data-mp="3emnyu0w9t5ta">
          <path d={COEUR_PATH} fill="#c6ecd6" data-id="element-1320" data-mp="2fqxkkhm65u4o" />
        </svg>

        <div className="relative mx-auto grid max-w-[1500px] items-center gap-12 px-5 lg:grid-cols-2 lg:gap-16 lg:px-10" data-id="element-1321" data-mp="2fpcp8ps1675r">
          <div className="pt-6 lg:pl-12" data-id="element-1322" data-mp="25t9onoctugkx">
            <p className="font-script text-5xl leading-none text-ville-navy lg:text-6xl" data-id="element-1323" data-mp="25shrwa7huct2">{seduction.script}</p>
            <h2 id="seduction-titre" className="-mt-3 max-w-md text-4xl font-extrabold leading-tight tracking-tight text-ville-coral lg:text-5xl" data-id="element-1324" data-mp="20vrdrsf91raa">
              {seduction.title}
            </h2>
          </div>

          <div className="grid grid-cols-2 grid-rows-2 gap-4" data-id="element-1325" data-mp="1n31qzlrwcic4">
            <img src={first} alt="" className="h-44 w-full rounded-sm object-cover lg:h-52" data-id="element-1326" data-mp="1n0ozoi090vme" />
            <img src={second} alt="" className="row-span-2 h-full w-full rounded-sm object-cover" data-id="element-1327" data-mp="1i2x67jjyh1g3" />
            <img src={third} alt="" className="h-44 w-full rounded-sm object-cover lg:h-52" data-id="element-1328" data-mp="1d5dryjn9coo5" />
          </div>
        </div>
      </section>

      <section aria-labelledby="cdew-titre" className="bg-ville-mist" data-id="element-1329" data-mp="18ftcoc3ajwvx">
        <div className="mx-auto grid max-w-[1500px] items-center gap-12 px-5 py-16 lg:grid-cols-[minmax(0,1fr)_minmax(0,42%)] lg:gap-16 lg:px-10 lg:py-0" data-id="element-1330" data-mp="18dq9srh1i99s">
          <div className="lg:py-20" data-id="element-1331" data-mp="yiybflfmvidy">
            <h2 id="cdew-titre" className="text-3xl font-extrabold leading-tight tracking-tight text-ville-navy lg:text-4xl" data-id="element-1332" data-mp="yjzqs23omr1h">
              {cdew.title}
            </h2>
            <p className="mt-5 max-w-2xl text-[17px] leading-relaxed text-ville-navy/80" data-id="element-1333" data-mp="1r59ed2qppvdx">{cdew.body}</p>
            <a href="#accueil" className={`mt-8 ${coralButton}`} data-id="element-1334" data-mp="1deo23wvrkjp0">
              {cdew.cta}
            </a>
          </div>

          <div className="relative mx-auto w-full max-w-[520px]" data-id="element-1335" data-mp="1heofde74mouh">
            <img src={cdew.image} alt="" className="coeur-mask aspect-square w-full object-cover" data-id="element-1336" data-mp="255k585s0v9z3" />
          </div>
        </div>
      </section>
    </>;
}